import { createContext, useContext, useMemo, useState, useEffect } from "react";

import useResponsive from "libs/helpers/useResponsive";

import FaqData from "libs/faq_data";

const FaqContext = createContext();

const FaqProvider = ({ children }) => {
  const { max } = useResponsive();

  const default_sort = "issue:asc";
  const [sort, setSort] = useState(default_sort);
  const [filter, setFilter] = useState("");
  const [selected, setSelected] = useState(null);

  const data = [].concat(
    ...FaqData().map((item) =>
      item.items.map((question) => ({
        title: question.title,
        category: {
          slug: item.slug,
          title: item.title,
        },
        content: question.content,
      })),
    ),
  );

  const dataFiltered = [...data].filter((item) =>
    filter !== "" ? item.category.slug === filter : item,
  );

  const dataSorted = dataFiltered.sort((a, b) => {
    const current_sort = sort.split(":");
    const key = current_sort[0];
    const method = current_sort[1];

    const a_str =
      key === "category"
        ? a.category.title
        : key === "issue"
          ? a.title
          : undefined;
    const b_str =
      key === "category"
        ? b.category.title
        : key === "issue"
          ? b.title
          : undefined;

    return method === "asc"
      ? a_str.localeCompare(b_str)
      : b_str.localeCompare(a_str);
  });

  useEffect(() => {
    setSort(default_sort);
  }, [filter]);

  useEffect(() => {
    if (max.lg) setSort(default_sort);
  }, [max.lg]);

  const value = useMemo(() => {
    return {
      data,
      dataSorted,
      sort,
      selected,
      filter,
      setSort,
      setSelected,
      setFilter,
    };
  }, [
    data,
    dataSorted,
    filter,
    sort,
    selected,
    setFilter,
    setSort,
    setSelected,
  ]);

  return <FaqContext.Provider value={value}>{children}</FaqContext.Provider>;
};

const useFaq = () => useContext(FaqContext);
export { FaqContext, useFaq };
export default FaqProvider;
